import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFound = () => {
    const {t}=useTranslation()
    return (
        <div className="flex-center flex-col  bg-white h-screen text-center ">
            <div className=' relative  overflow-hidden h-52'>
                <img src="/asset/not-found.png" className='w-full h-full' loading='lazy' alt="not-found" />
            </div>
            <p className="text-2xl text-darkColor mb-8">{t("page-not-found")}</p>
            <Link to="/" className="px-4 py-2 bg-primary text-white rounded-full hover:bg-secondary">
                {t("go-home")}
            </Link>
        </div>
    );
}

export default NotFound